import React, { useState, useEffect } from 'react'
import clx from 'classnames'
import { Menu, Anchor } from 'antd'
import { Icon } from '@vzmi/shp_shared_compo'
import _ from 'lodash'
import styles from './index.css'
import { HyperLink } from '../../Form'
const { Link } = Anchor

const getMenuItems = (selectedKey, items) => _.map(items, (item = {}, index) => {
  const {
    path,
    label,
    icon
  } = item
  const subItems = _.get(label, 'props.subItems', [])
  const newSubItems = _.map(subItems, item => {
    const { link, linkTitle, highlight, ...restProps } = item
    return {
      label: (
        <Link
          href={`#${link}`}
          title={linkTitle}
          {...restProps}
        >
          {highlight && (
            <Icon
              name={'ec-flash'}
              size={28}
              color="#FFDE00"
              className={styles.hightlightIcon}
            />
          )}
        </Link>
      )
    }
  })
  const key = path || index
  const menuItem = {
    key,
    label: path
      ? (
        <HyperLink href={path}>
          {label}
        </HyperLink>
      )
      : label,
    icon: icon
      ? (
        <Icon
          color={selectedKey === `${key}` ? '#5478fc' : null}
          name={icon}
          size={14}
        />
      )
      : null
  }
  const newMenuItem = {
    ...menuItem,
    ...(!_.isEmpty(subItems) && { children: newSubItems })
  }
  return newMenuItem
})

const SideBar = props => {
  const {
    items,
    onSelect: onSelectProps,
    className,
    defaultSelected,
    ...restProps
  } = props
  const [selectedKey, setSelectedKey] = useState(null)
  const onSelect = (selectProps = {}) => {
    const { key } = selectProps
    setSelectedKey(key)
    onSelectProps && onSelectProps(selectProps)
  }

  useEffect(() => {
    setSelectedKey(defaultSelected)
  }, [defaultSelected])

  return (
    <Menu
      className={clx(
        styles.sidebar,
        { [className]: className }
      )}
      items={getMenuItems(selectedKey, items)}
      onSelect={onSelect}
      selectedKeys={[selectedKey]}
      mode="inline"
      defaultOpenKeys={['4']}
      {...restProps}
    />
  )
}

export default SideBar
